import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

// Components
import EditIcon from '@icons/EditIcon';
import TrashIcon from '@icons/TrashIcon';
import { ButtonNoStyles } from '@styled';

const PropertyListItemListedIcons = ({ id, onDeleteClick }) => {
    return (
        <div>
            <Link to={`/my-icsc/properties/${id}/edit`}>
                <EditIcon />
            </Link>

            <ButtonNoStyles style={{ cursor: 'pointer' }} onClick={onDeleteClick}>
                <TrashIcon />
            </ButtonNoStyles>
        </div>
    );
};

PropertyListItemListedIcons.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onDeleteClick: PropTypes.func.isRequired,
};

export default PropertyListItemListedIcons;
